import $api from "@/api/index";

import { setUserStatus } from "@/api/user";
import { useTariffLayer } from "@/store/mode";
import { TariffMode } from "@/types/base";

export async function trackAppOpen({
  first_time,
  version,
}: {
  first_time: boolean;
  version: string;
}): Promise<void> {
  if (first_time) await setUserStatus({ status: "OPEN_APP" });

  const alreadyOpened = sessionStorage.getItem("app_opened");
  if (alreadyOpened && version === alreadyOpened) return;

  await $api.post(`/v2/users/app-opens`, { app_version: version });
  sessionStorage.setItem("app_opened", version);
}

export async function trackMetadata({
  lon,
  lat,
  selected_tariff,
}: {
  lon?: number;
  lat?: number;
  selected_tariff: TariffMode;
}) {
  const response = await $api.post(`/v2/users/context`, {
    point: { lon: lon || null, lat: lat || null },
    selected_tariff,
  });

  return response.data;
}

export async function postAdEvent({
  service_type,
  event_type,
}: {
  service_type: "taxi" | "delivery";
  event_type?: "rent_icon_view" | "rent_icon_click" | "rent_form_open";
}) {
  const color = service_type === "taxi" ? "yellow" : "red";

  const response = await $api.post(`/v2/users/event`, {
    service_type,
    event_type,
    ...(event_type === "rent_icon_click" ? { icon_color: color } : {}),
  });

  return response.data;
}

export async function postEdaMainEvent({
  event_type,
}: {
  event_type: "eda_icon_click" | "eda_popup_click" | "wallet_icon_click";
}) {
  const service_type = useTariffLayer.getState().serviceLayer;

  const response = await $api.post(`/v2/users/event`, {
    event_type,
    service_type,
  });

  return response.data;
}

export async function postGeoPinClickEvent({
  service_type,
}: {
  service_type: "taxi" | "eda";
}) {
  const response = await $api.post(`/v2/users/event`, {
    event_type: "geo_pin_click",
    service_type,
  });

  return response.data;
}
